/* eslint-disable import/extensions */
import Grid from 'common/components/Grid'
import Image from 'common/components/Image'
import Skeleton from 'common/components/Skeleton'
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import { useStoreActions, useStoreState } from 'easy-peasy'
import cdn from 'lib/cdn'
import { useEffect } from 'react'
import useInView from 'react-cool-inview'
import { useTranslation } from 'react-i18next'
import IProductHomepageModel from 'stores/models/interface'
import styled from 'styled-components'

import Carousel from '../components/product-carousel'

const Container = styled.div`
  width: ${theme.layout.containerWidth};
  margin: 50px auto 0;
`

const TitleAndShowAllContainer = styled.div`
  width: ${theme.layout.containerWidth};
  margin-bottom: 20px;
`

const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const ProductContainer = styled.div`
  width: ${theme.layout.containerWidth};
  height: 325px;
  background-color: ${(props) => props.backgroundColor};
  display: flex;
  border-radius: 6px;
  overflow-x: hidden;
`

const BannerContainer = styled.div`
  display: ${(props) => (!props.categoryBanner ? 'none' : 'block')};
  width: 290px;
  height: 325px;
`

function ProductHomepage(): JSX.Element {
  const { i18n } = useTranslation()
  const { categoryProduct, isLoading, isError } = useStoreState<
    IProductHomepageModel
  >((state) => state.productHomepage)

  const { getCategoryProduct } = useStoreActions<
    IProductHomepageModel
  >((actions) => actions.productHomepage)

  const { observe, inView } = useInView<HTMLDivElement>({
    onEnter: ({ unobserve }) => unobserve(),
  })

  useEffect(() => {
    if (inView && !isError) {
      getCategoryProduct()
    }
  }, [getCategoryProduct, inView, isError, i18n.language])

  return (
    <div data-testid="product-homepage-test" ref={observe}>
      {isLoading && (
        <Container>
          <Skeleton width="100%" height="325px" />
        </Container>
      )}
      {categoryProduct?.data?.length && !isLoading && !isError
        ? categoryProduct?.data?.map((dataByCategory, index) => {
            const products =
              dataByCategory?.items?.length > 10
                ? dataByCategory?.items.slice(0, 10)
                : dataByCategory?.items

            return (
              <>
                {products?.length ? (
                  <Container key={`category-${index + 1}`}>
                    <TitleAndShowAllContainer>
                      <Grid templateColumn={2}>
                        <>
                          <Title>
                            <Typography type="bh2">
                              {dataByCategory.title}
                            </Typography>
                          </Title>
                        </>
                      </Grid>
                    </TitleAndShowAllContainer>
                    <ProductContainer
                      backgroundColor={
                        dataByCategory.backgroundColor || ''
                      }
                    >
                      <BannerContainer
                        categoryBanner={dataByCategory.bannerImage}
                      >
                        <Image
                          width="260px"
                          height="325px"
                          lazy
                          src={cdn({
                            path: `/${dataByCategory.bannerImage}`,
                          })}
                          objectFit="fit-cover"
                          borderTopLeftRadius="6px"
                          borderBottomLeftRadius="6px"
                        />
                      </BannerContainer>
                      <Carousel
                        products={products}
                        isBannerExist={!!dataByCategory.bannerImage}
                      />
                    </ProductContainer>
                  </Container>
                ) : null}
              </>
            )
          })
        : null}
    </div>
  )
}

export default ProductHomepage
